// extracted by mini-css-extract-plugin
module.exports = {"title":"SquareCardList_title___2xfU"};